import { render, staticRenderFns } from "./ArticleTitleHead.vue?vue&type=template&id=336ed717&scoped=true&"
import script from "./ArticleTitleHead.vue?vue&type=script&lang=js&"
export * from "./ArticleTitleHead.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTitleHead.vue?vue&type=style&index=0&id=336ed717&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336ed717",
  null
  
)

export default component.exports